import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import PublishersGrid from '../components/Grid';
import { PublisherProvider } from '../store';

import PublisherFormLayout from './Form';

export default function PublishersGridLayout() {
  return <PublisherProvider>
    <PublishersGrid />
    <Router>
      <PrivateRoute path={["/offer/publishers/add", "/offer/publishers/:id"]} component={PublisherFormLayout} />
    </Router>
  </PublisherProvider>;
}
